import { __rest } from "tslib";
import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";
const buttonVariants = cva("inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50", {
    variants: {
        variant: {
            default: "bg-skvelightblue-700 text-white/90 hover:bg-skvedarkblue/90 dark:hover:bg-skvedarkblue/95",
            destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
            outline: "border border-input hover:bg-accent hover:text-accent-foreground",
            secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
            ghost: "hover:bg-accent hover:text-accent-foreground",
            link: "text-primary underline-offset-4 hover:underline",
            control: "bg-white rounded-sm",
        },
        size: {
            default: "h-10 px-4 py-2",
            sm: "h-9 rounded-md px-3",
            lg: "h-11 rounded-md px-8",
            icon: "h-10 w-10",
            edit: "p-1",
            pen: "p-1 border-0",
        },
    },
    defaultVariants: {
        variant: "default",
        size: "default",
    },
});
/**
 * @variations Default,Destructive,Secondary,Ghost,Outline
 * @example
 *
 * ```jsx
 * import { Button } from "@skve/components"
 *
 * function DemoDefault() {
 *   return <Button>Button</Button>
 * }
 *
 * function DemoDestructive() {
 *   return <Button variant="destructive">Button</Button>
 * }
 *
 * function DemoSecondary() {
 *   return <Button variant="secondary">Button</Button>
 * }
 *
 * function DemoGhost() {
 *   return <Button variant="ghost">Button</Button>
 * }
 *
 * function DemoOutline() {
 *   return <Button variant="outline">Button</Button>
 * }
 * ```
 */
const Button = React.forwardRef((_a, ref) => {
    var { className, variant, size, asChild = false } = _a, props = __rest(_a, ["className", "variant", "size", "asChild"]);
    const Comp = asChild ? Slot : "button";
    return (React.createElement(Comp, Object.assign({ className: cn(buttonVariants({ variant, size, className })), ref: ref }, props)));
});
Button.displayName = "Button";
export { Button, buttonVariants };
//# sourceMappingURL=button.js.map